/**
 * Created by Mark on 18/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import {Glyphicon , OverlayTrigger , Tooltip , ControlLabel , Row , Col , FormGroup , FormControl , Table} from 'react-bootstrap';
import Correct from '../../inputs/tickbox.js';
import AssignmentStore from '../../../store/assignment-store.js';
import AssignmentService    from '../../../services/assignment-services.js';
import IntelStore from "../../../store/internationalization-store.js"
import SelectLanguage from './homework-language.js';
import SelectType from './homework-type.js';
import VocabularyContent from './vocabulary-builder/vocabulary-content.js';
import CustomContent from './vocabulary-builder/custom-content.js';
import VerbBuilder from './verb-builder/verb-builder.js';
import AssignAssignments from './assign-assignments.js';
import Save from './save-assignment.js';
import VocabularySettings from './vocabulary-builder/vocabulary-settings.js';

class ContentStep extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.props.data.features = this.props.data.features || [];
        this.state = {
            selected:this.props.data.features
        };
    }

    componentDidMount(){
        AssignmentService.getFeatures();
    }

    componentWillMount(){
        AssignmentStore.on('ON_GET_HOMEWORK_FEATURES' , ()=> {
            this.setState({features:AssignmentStore.avalibleFeatures})
        })
    }

    isSelected(item){

        for(var index = 0 ; index < this.state.selected.length; index++)
        {
            if(this.state.selected[index].uid == item.uid) return true
        }
        
        return false
    }

    onSelect(item){


        let selected = this.state.selected;


        AssignmentService.setHomeworkType(this.props.data.homeworkID , item.uid , !this.isSelected(item));

        if(this.isSelected(item))
        {
            for(var index = 0 ; index < this.state.selected.length; index++)
            {
                if(this.state.selected[index].uid == item.uid) selected.splice(index , index + 1)
            }
        }
        else
        {
            selected.push(item);
        }


        this.props.data.features = selected;
        this.modifyWizard();
        this.setState({selected:selected})
    }

    modifyWizard(){

        var steps = [SelectLanguage , SelectType];

        for(var idx = 0; idx < this.props.data.features.length; idx++){

            var feature = this.props.data.features[idx];
            switch(String(feature.uid))
            {
                case "1" : steps = steps.concat([VocabularyContent , VocabularySettings]); break;
                case "2" : steps = steps.concat([VerbBuilder]); break;
                case "3" : steps = steps.concat([]); break;
                case "4" : steps = steps.concat([]); break;
                case "5" : steps = steps.concat([]); break;
                case "6" : steps = steps.concat([CustomContent , VocabularySettings]); break;
            }
        }

        steps = steps.concat([AssignAssignments , Save]);

        this.props.onModify(steps)
    }

    render(){

        if(!this.state.features) return null;


        let features = this.state.features.map(function(feature){
            return <Row><Col md={12}>
                        <div className="b-1 m-b-10" onClick={this.onSelect.bind(this , feature)} >

                            <div  style={{width:'100%' , textAlign:'left'}} className="p-10 vert-center">
                                <h5  style={{margin:0}}> {feature.name}</h5>
                            </div>
                            <div  style={{width:50}} className="p-10 vert-center">
                                <Correct selected={this.isSelected(feature)} onSelected={this.onSelect.bind(this , feature)}/>
                            </div>
                        </div>
                    </Col></Row>
        }.bind(this));


        return <div>
                    {features}
                </div>
    }
}

export default {
    name: <FormattedMessage id={ 'ui-00' } defaultMessage={ 'Select Type' }/>,
    title:null,
    disableButtons:false,
    onSubmit: function (done){

        if(this.props.data.features.length > 0)
        {
            done();
        }
        else
        {
            done(new Error(IntelStore.getTranslation("ui-673")));
        }

    },
    component: ContentStep
}


// WEBPACK FOOTER //
// ./src/components/wizard/homework-steps/homework-type.js